import React from 'react';
import { BookOpen, Leaf, Coffee, Droplets, Scale } from 'lucide-react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Card, CardContent } from '@/components/ui/card';

const ratgeberItems = [
    {
        icon: Leaf,
        title: 'Ziel & Routine festlegen',
        description:
            'Wollen Sie eher ein tägliches Wohlfühl-Ritual, einen Fokus auf „Bauchgefühl“ oder eine Abnehm-/Detox-Routine? Wählen Sie danach Geschmack, Koffein und Zutatenprofil.',
    },
    {
        icon: Coffee,
        title: 'Koffein & Tageszeit prüfen',
        description:
            'Für morgens/mittags passt oft ein Tee mit leichtem Koffein. Für abends sind koffeinfreie Optionen angenehmer. Achten Sie auf klare Angaben des Anbieters.',
    },
    {
        icon: Droplets,
        title: 'Zutaten & Verträglichkeit',
        description:
            'Lesen Sie die Zutatenliste (Allergene!) und starten Sie bei sensiblen Mägen langsam. Kräuter werden teils als „entwässernd“ beworben – Wirkung ist individuell.',
    },
    {
        icon: Scale,
        title: 'Preis/Portion + Garantie vergleichen',
        description:
            'Vergleichen Sie Preis pro Portion (nicht nur den Gesamtpreis) und prüfen Sie Garantie/Rückgabe. Das senkt das Risiko beim ersten Test.',
    },
];

export const RatgeberSection = () => {
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section id="ratgeber" className="py-16 md:py-24">
            <div ref={ref} className="section-container">
                {/* Section Header */}
                <div
                    className={`text-center mb-10 ${
                        isVisible ? 'animate-fade-in-up' : 'opacity-0'
                    }`}
                >
                    <div className="inline-flex items-center gap-2 text-primary mb-3">
                        <BookOpen className="h-5 w-5" />
                        <span className="text-sm font-semibold uppercase tracking-wide">
                            Ratgeber
                        </span>
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
                        In 4 Schritten zum passenden Tee
                    </h2>
                    <p className="text-muted-foreground max-w-2xl mx-auto">
                        Kurz-Guide für eine schnelle Entscheidung – mit Blick auf Routine,
                        Geschmack, Koffein, Zutatenprofil und Risiko (Garantie).
                    </p>
                </div>

                {/* Ratgeber Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {ratgeberItems.map((item, index) => (
                        <Card
                            key={item.title}
                            className={`border border-border hover:shadow-card transition-shadow duration-300 ${
                                isVisible ? 'animate-fade-in-up' : 'opacity-0'
                            }`}
                            style={{ animationDelay: `${0.1 + index * 0.1}s` }}
                        >
                            <CardContent className="p-6">
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                                        <item.icon className="h-6 w-6 text-primary" />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-foreground mb-2">
                                            {item.title}
                                        </h3>
                                        <p className="text-sm text-muted-foreground leading-relaxed">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>

                {/* Disclaimer */}
                <p
                    className={`text-xs text-muted-foreground text-center mt-8 max-w-2xl mx-auto ${
                        isVisible ? 'animate-fade-in' : 'opacity-0'
                    }`}
                    style={{ animationDelay: '0.5s' }}
                >
                    Hinweis: Diese Informationen dienen ausschließlich der
                    Produktorientierung. Keine medizinische Beratung; individuelle
                    Erfahrungen können variieren.
                </p>
            </div>
        </section>
    );
};
